import { CoverLetterType } from 'generated/graphql'

export const COVER_LETTER_TYPE_TEXT_OBJECT = {
  [CoverLetterType.ALL]: '전체',
  [CoverLetterType.MAJOR_COMPANY]: '대기업',
  [CoverLetterType.MEDIUM_COMPANY]: '중견기업',
  [CoverLetterType.SMALL_COMPANY]: '중소기업/스타트업',
  [CoverLetterType.PUBLIC_INSTITUTIONS]: '공기업',
  [CoverLetterType.BANKS]: '은행권',
  [CoverLetterType.ETC]: '기타',
  [CoverLetterType.INTERN]: '인턴',
  [CoverLetterType.NEWCOMER]: '신입',
}
